import React from "react";
import "./GooglePlayMusicForArtists.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";

const GooglePlayMusicForArtists = () => {

  const steps = [
    "Create your FTTunes account",
    "Upload music & artwork",
    "Deliver music to Google Play Music",
    "Publish across Android ecosystem",
    "Reach global listeners",
    "Track streams & royalties"
  ];

  return (
    <>
      <Helmet>

        <title>
          Get Your Music on Google Play Music | FT Tunes Distribution
        </title>

        <meta
          name="description"
          content="Distribute your music to Google Play Music and reach Android users worldwide. Grow your audience and earn streaming royalties with FT Tunes music distribution."
        />

        <meta
          name="keywords"
          content="Google Play Music distribution, upload music Google Play Music, music distribution Android, FT Tunes music distribution"
        />

        <meta name="robots" content="index, follow" />

        <meta
          property="og:title"
          content="Get Your Music on Google Play Music | FT Tunes"
        />

        <meta
          property="og:url"
          content="https://www.fttunes.com/get-your-music-on-google-play-music"
        />

      </Helmet>

      <div className="googlemusic-page">

        {/* HERO */}
        <section className="googlemusic-hero">
          <Container>

            <img
              src="/Images/google-play-music-log.svg"
              alt="Google Play Music Distribution"
              className="googlemusic-logo"
            />

            <h1>Get Your Music on Google Play Music</h1>

            <p>
              Distribute your music to Google Play Music and reach millions of
              Android users worldwide. Expand your global fanbase, grow your
              streaming presence, and monetize your music through the powerful
              Google ecosystem. With FT Tunes music distribution, artists can
              release singles, EPs, and albums quickly while maintaining full
              ownership and earning streaming royalties across supported
              platforms.
            </p>

            <Button
              className="gradient-btn"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Start Releasing Music
            </Button>

          </Container>

          <div className="hero-glow-google"></div>
        </section>

        {/* SHOWCASE */}
        <section className="googlemusic-showcase">
          <Container>
            <Row className="align-items-center">

              <Col md={6}>
                <h2>Reach Android Listeners Worldwide</h2>

                <p>
                  Publish your music across Google's global ecosystem and
                  connect with listeners using Android devices and Google
                  streaming platforms.
                </p>

                <Button
                  className="outline-btn"
                  href="https://dashboard.fttunes.com/register.php"
                  target="_blank"
                >
                  Distribute Now
                </Button>
              </Col>

              <Col md={6}>
                <img
                  src="/Images/get-music-on-google-play-music.png"
                  alt="Google Play Music artists"
                  className="googlemusic-image"
                />
              </Col>

            </Row>
          </Container>
        </section>

        {/* STEPS */}
        <section className="googlemusic-steps">
          <Container>

            <h2 className="section-title">How It Works</h2>

            <Row>
              {steps.map((step, index) => (
                <Col md={4} key={index}>
                  <div className="step-card">
                    <span>0{index + 1}</span>
                    <p>{step}</p>
                  </div>
                </Col>
              ))}
            </Row>

          </Container>
        </section>

        {/* BENEFITS */}
        <section className="googlemusic-benefits">
          <Container>

            <h2 className="section-title">
              Built For Independent Artists
            </h2>

            <Row>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Global Android Reach</h5>
                  <p>Access millions of Android listeners worldwide.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>100% Ownership</h5>
                  <p>You keep full rights to your music.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Streaming Revenue</h5>
                  <p>Earn royalties from every stream.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Artist Growth</h5>
                  <p>Grow your audience through global discovery.</p>
                </div>
              </Col>

            </Row>

          </Container>
        </section>

        {/* CTA */}
        <section className="googlemusic-cta">
          <Container>

            <h2>Start Growing on Google Play Music</h2>

            <Button
              className="gradient-btn big"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Upload Your Music
            </Button>

          </Container>
        </section>

      </div>
    </>
  );
};

export default GooglePlayMusicForArtists;